import { styled } from '@mui/material/styles';
import { ListItemButton } from '@sunwisesoftware/sunwise-ui';

const StyledListItemButton = styled(ListItemButton)(
    ({ theme, size, variant }) => ({
        alignItems: 'center',
        borderLeft: '4px solid transparent',
        borderRight: '4px solid transparent',
        display: 'flex',
        flexDirection: variant === 'horizontal' ? 'row' : 'column',
        gap: '4px',
        justifyContent: 'center',
        padding: variant === 'horizontal' ? '16px' : '16px 4px',
        '& svg': {
            height: '24px',
            width: '24px',
        },
        '& svg path': {
            fill: theme.palette.primary.main,
        },
        '& .MuiListItemText-primary': {
            color: theme.palette.mode === 'dark' ? '#fff' : '#000',
            fontSize: '11px',
            textAlign: 'center',
        },
        '&:hover': {
            '& svg': {
                transform: 'scale(1.14)',
            },
            '& svg path': {
                fill: theme.palette.primary.main,
            },
            '& .MuiListItemText-primary': {
                color:
                    theme.palette.mode === 'dark'
                        ? '#fff'
                        : theme.palette.primary.main,
            },
        },
        '&.Mui-selected, &.Mui-selected:hover': {
            background: 'transparent',
            borderRight: `4px solid ${theme.palette.primary.main}`,
            '& svg path': {
                fill: theme.palette.primary.main,
            },
            '& .MuiListItemText-primary': {
                color:
                    theme.palette.mode === 'dark'
                        ? '#fff'
                        : theme.palette.primary.main,
            },
        },
        [theme.breakpoints.down('md')]: {
            flexDirection: 'row',
            justifyContent: 'left',
            paddingLeft: '16px',
            paddingRight: '16px',
            gap: '8px',
            '& .MuiListItemText-primary': {
                fontSize: '16px',
                textAlign: 'left',
            },
            '&.Mui-selected, &.Mui-selected:hover': {
                background: 'rgba(34, 64, 153, 0.08)',
            },
        },
        ...(size === 'small' && {
            [theme.breakpoints.up('md')]: {
                '& .MuiListItemText-root': { display: 'none' },
            },
        }),
    }),
);

export default StyledListItemButton;
